// frontend/src/components/EditCircleDetailsModal.jsx

import React from "react";
import { X } from "phosphor-react";

export default function EditCircleDetailsModal({
  open,
  onClose,
  onSave,
  draftNameAll,
  setDraftNameAll,
  draftCityAll,
  setDraftCityAll,
  draftCountryCodeAll,
  setDraftCountryCodeAll,
  draftWebsiteAll,
  setDraftWebsiteAll,
  draftDescriptionAll,
  setDraftDescriptionAll,
  countryOptions = [],
  draftLocationLabel,
  codeToFlag,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      <div className="relative z-10 w-full sm:max-w-lg max-w-[350px] bg-white rounded-2xl sm:shadow-[0_8px_0px_rgba(37,99,235,0.96)] overflow-hidden">
        <div className="px-5 py-4 flex items-center justify-between">
          <h3 className="font-semibold text-blue-600">Edit Circle Details</h3>

          <button
            type="button"
            onClick={onClose}
            className="text-gray-800"
            aria-label="Close"
          >
            <X size={18} weight="bold" />
          </button>
        </div>

        <div className="px-5 space-y-2">
          <div>
            <label className="block text-sm font-medium ml-2 mb-1">
              Circle Name
            </label>
            <input
              type="text"
              value={draftNameAll}
              onChange={(e) => setDraftNameAll(e.target.value)}
              placeholder="Circle name"
              className="w-full text-sm border rounded-2xl px-3 py-1 focus:outline-none focus:ring-1 focus:ring-blue-600"
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-start gap-4">
            <div className="flex-1">
              <label className="block ml-2 text-sm font-medium mb-1">
                City <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="e.g. New York"
                value={draftCityAll}
                onChange={(e) => setDraftCityAll(e.target.value)}
                className="w-full text-sm border rounded-2xl px-3 py-1 focus:outline-none focus:ring-1 focus:ring-blue-600"
              />
            </div>

            <div className="flex-1">
              <label className="block ml-2 text-sm font-medium mb-1">
                Country <span className="text-red-500">*</span>
              </label>

              <div className="relative">
                <select
                  value={draftCountryCodeAll}
                  onChange={(e) => setDraftCountryCodeAll(e.target.value)}
                  className="w-full text-sm border rounded-2xl px-3 py-1 focus:outline-none focus:ring-1 focus:ring-blue-600"
                >
                  <option value="" disabled>
                    Select country
                  </option>

                  {countryOptions.map((opt) => (
                    <option key={opt.code} value={opt.code}>
                      {opt.name}
                    </option>
                  ))}
                </select>

                <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
              </div>
            </div>
          </div>

          <div className="ml-3 text-sm text-gray-600">
            {draftCountryCodeAll
              ? `${codeToFlag?.(draftCountryCodeAll) || ""} ${draftLocationLabel || ""}`
              : draftLocationLabel}
          </div>

          <div>
            <label className="block ml-2 text-sm font-medium mb-1">Website</label>
            <input
              type="url"
              placeholder="https://example.com"
              value={draftWebsiteAll}
              onChange={(e) => setDraftWebsiteAll(e.target.value)}
              className="w-full text-sm border rounded-2xl px-3 py-1 focus:outline-none focus:ring-1 focus:ring-blue-600"
            />
          </div>

          <div>
            <label className="block ml-2 text-sm font-medium mb-1">
              Description
            </label>
            <textarea
              rows={4}
              value={draftDescriptionAll}
              onChange={(e) => setDraftDescriptionAll(e.target.value)}
              placeholder="Tell us about your circle!"
              className="w-full text-sm border rounded-2xl px-3 py-1 focus:outline-none focus:ring-1 focus:ring-blue-600"
            />
          </div>
        </div>

        <div className="flex px-4 pt-2 pb-4 items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-100 hover:ring-2 hover:ring-gray-300 rounded-full !min-h-0 !min-w-0 !px-3 !py-1 text-sm"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={onSave}
            className="bg-blue-200 hover:ring-2 hover:ring-300 rounded-full !min-h-0 !min-w-0 !px-3 !py-1 text-sm"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}